import React from "react";
import { useTranslation } from "react-i18next";
import {
  LuArrowLeft,
  LuImagePlus,
  LuSend,
} from "react-icons/lu";

import ImageUpload from "./ImageUpload";

const ImageUploadSection = ({
  onImagesChange,
  handlePrevious,
  submitting = false,
  maxImages = 6,
  initialImages,
}) => {
  const { t } = useTranslation();

  return (
    <section>
      {/* En-tête */}
      <div className="mb-7">
        <p className="text-xs font-black uppercase tracking-[0.18em] text-green-600">
          {t("create.step_6", "Étape 6")}
        </p>

        <h3 className="mt-2 text-2xl font-black text-slate-950">
          {t(
            "create.photos_title",
            "Ajoutez les photos de votre bien"
          )}
        </h3>

        <p className="mt-2 text-sm leading-6 text-slate-500">
          {t(
            "create.photos_description",
            "Ajoutez des photos lumineuses et de bonne qualité pour rendre votre annonce plus attractive."
          )}
        </p>
      </div>

      {/* Zone upload */}
      <div
        className="
          rounded-3xl
          border
          border-dashed
          border-slate-300
          bg-slate-50/70
          p-4
          transition
          hover:border-green-300
          hover:bg-green-50/40
          sm:p-6
        "
      >
        <div className="mb-5 flex items-start gap-3">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-green-100 text-green-600">
            <LuImagePlus size={21} />
          </span>

          <div>
            <h4 className="text-sm font-black text-slate-900">
              {t(
                "create.upload_photos",
                "Importer vos photos"
              )}
            </h4>

            <p className="mt-1 text-xs leading-5 text-slate-500">
              {t(
                "create.upload_photos_help",
                "Choisissez une belle photo principale puis ajoutez les différentes pièces et les équipements."
              )}
            </p>
          </div>
        </div>

        <ImageUpload onImagesChange={onImagesChange} maxImages={maxImages} initialImages={initialImages} />
      </div>

      {/* Conseils */}
      <div className="mt-5 rounded-2xl border border-amber-100 bg-amber-50 px-4 py-3">
        <p className="text-sm font-bold text-amber-800">
          {t(
            "create.photo_tips_title",
            "Conseils"
          )}
        </p>

        <p className="mt-1 text-xs leading-5 text-amber-700">
          {t(
            "create.photo_tips",
            "Utilisez des photos horizontales, nettes et lumineuses. Évitez les images floues ou trop sombres."
          )}
        </p>
      </div>

      {/* Navigation */}
      <div className="mt-8 flex flex-col-reverse gap-3 border-t border-slate-100 pt-6 sm:flex-row sm:justify-between">
        {/* <button
          type="button"
          onClick={handlePrevious}
          className="
            inline-flex
            h-12
            items-center
            justify-center
            gap-2
            rounded-2xl
            border
            border-slate-200
            bg-white
            px-6
            text-sm
            font-bold
            text-slate-700
            transition
            hover:border-slate-300
            hover:bg-slate-100
            focus:outline-none
            focus:ring-4
            focus:ring-slate-500/10
          "
        >
          <LuArrowLeft
            size={17}
            className="rtl:rotate-180"
          />

          {t("previous", "Précédent")}
        </button> */}

        {/* <button
          type="submit"
          disabled={submitting}
          className="
            inline-flex
            h-12
            items-center
            justify-center
            gap-2
            rounded-2xl
            bg-green-600
            px-7
            text-sm
            font-black
            text-white
            shadow-lg
            shadow-green-600/20
            transition-all
            hover:-translate-y-0.5
            hover:bg-green-700
            disabled:cursor-not-allowed
            disabled:bg-slate-300
            disabled:shadow-none
            focus:outline-none
            focus:ring-4
            focus:ring-green-500/20
          "
        >
          {submitting ? (
            <>
              <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white" />

              {t(
                "sending",
                "Publication..."
              )}
            </>
          ) : (
            <>
              <LuSend size={17} />

              {t(
                "create.publish",
                "Publier l’annonce"
              )}
            </>
          )}
        </button> */}
      </div>
    </section>
  );
};

export default ImageUploadSection;